import { TabStack } from '@/components/TabStack';

export default function InboxTabLayout() {
  return <TabStack tab="inbox" />;
}
